import tinycolor from 'tinycolor2';

var Theme;
(function (Theme) {
  Theme.getLight = function () {
    return {
      badgeInteractiveBackgroundActive: tinycolor('black').setAlpha(0.1).toHslString(),
      badgeInteractiveBackgroundHover: tinycolor('black').setAlpha(0.05).toHslString()
    };
  };
  Theme.getDark = function () {
    return {
      badgeInteractiveBackgroundActive: tinycolor('black').setAlpha(0.2).toHslString(),
      badgeInteractiveBackgroundHover: tinycolor('black').setAlpha(0.1).toHslString()
    };
  };
})(Theme || (Theme = {}));

export { Theme };
